import templates from './templates';
import './index.styl';

import { CoreRegenerationInviteView } from '../../../../../core/views';

/**
 *
 */
export default class RegenerationInviteView extends CoreRegenerationInviteView {
	getTemplate() {
		let count_users = this.model.get( 'num_teams' );

		if ( count_users < 20 ) {
			return templates.invite;
		}
		else {
			return templates.invite_all;
		}
	}
}